import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { PublicFormsService } from '@core/services/public-forms/public-forms.service';
import { PhoneInputComponent } from '@shared/components/forms/phone-input/phone-input.component';
import { ButtonModule } from 'primeng/button';
import { FloatLabel } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';

type FormStatus = 'idle' | 'loading' | 'success' | 'error';

@Component({
  selector: 'd2d-subscriber-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    FloatLabel,
    PhoneInputComponent,
    TranslocoPipe,
  ],
  templateUrl: './subscriber-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './subscriber-form.component.scss',
})
export class SubscriberFormComponent {
  private readonly formsService = inject(PublicFormsService);

  readonly formStatus = signal<FormStatus>('idle');

  subscriberForm = new FormGroup({
    company_name: new FormControl('', [Validators.required, Validators.minLength(2)]),
    name: new FormControl('', [Validators.required, Validators.minLength(2)]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required]),
  });

  get isLoading(): boolean {
    return this.formStatus() === 'loading';
  }

  get isSuccess(): boolean {
    return this.formStatus() === 'success';
  }

  get isError(): boolean {
    return this.formStatus() === 'error';
  }

  onSubmit(): void {
    if (this.subscriberForm.invalid) {
      this.subscriberForm.markAllAsTouched();
      return;
    }

    this.formStatus.set('loading');

    const { company_name, name, email, phone } = this.subscriberForm.value;

    this.formsService
      .submitLead({
        company_name: company_name!,
        name: name!,
        email: email!,
        phone: phone!,
      })
      .subscribe({
        next: () => this.formStatus.set('success'),
        error: () => this.formStatus.set('error'),
      });
  }
}
